// `/businesses` — list route (US-104).

import { createRoute } from '@tanstack/react-router';

import { BusinessesListPage } from '@/features/businesses/BusinessesListPage';

import { Route as BusinessesLayoutRoute } from './__layout';

export const Route = createRoute({
  getParentRoute: () => BusinessesLayoutRoute,
  path: '/',
  component: BusinessesIndex,
});

function BusinessesIndex() {
  return <BusinessesListPage />;
}
